<div class="row">
    <div class="box">
        <div class="col-xs-12">
            <mat-spinner></mat-spinner>
            <span class="spinner__message" *ngIf="message !== ''"><br />{{ message }}</span>
        </div>
    </div>
</div>
